import { render, staticRenderFns } from "./clientBillingSummary.vue?vue&type=template&id=f02a1f4c"
import script from "./clientBillingSummary.vue?vue&type=script&lang=js"
export * from "./clientBillingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports